import React, { createContext, PropsWithChildren, useContext } from 'react';

interface ThreeDotsQuoteContextProps {
  anchorEl: HTMLElement | null;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  closeThreeDotsQuote: () => void;
}

const ThreeDotsQuoteContext = createContext<ThreeDotsQuoteContextProps | undefined>(undefined);

export const useThreeDotsQuoteContext = () => {
  const context = useContext(ThreeDotsQuoteContext);
  if (!context) {
    throw new Error(
      'useThreeDotsQuoteContext must be used within a ThreeDotsQuoteProvider'
    );
  }
  return context;
};

interface IThreeDotsQuoteProviderProps { }
export const ThreeDotsQuoteProvider: React.FC<PropsWithChildren<IThreeDotsQuoteProviderProps>> = ({
  children,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  function closeThreeDotsQuote() {
    setAnchorEl(null);
  }

  return (
    <ThreeDotsQuoteContext.Provider
      value={{
        anchorEl,
        setAnchorEl,
        closeThreeDotsQuote
      }}
    >
      {children}
    </ThreeDotsQuoteContext.Provider>
  );
};
